import { render, staticRenderFns } from "./RacePriceColumn.vue?vue&type=template&id=3ddf9333&scoped=true"
import script from "./RacePriceColumn.vue?vue&type=script&lang=js"
export * from "./RacePriceColumn.vue?vue&type=script&lang=js"
import style0 from "./RacePriceColumn.vue?vue&type=style&index=0&id=3ddf9333&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ddf9333",
  null
  
)

export default component.exports